/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { ChevronUp, ChevronDown } from 'react-feather';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';
import EditButton from '../../common/buttons/EditButton';
import DeleteButton from '../../common/buttons/DeleteButton';
import dateFormat from '../../../utils/dateFormat';


const TableComponent = ({
  data, onOrderByChange, openDeleteModal, orderBy, ascending,
}) => {
  const { t } = useTranslation(['translation'])
  const classes = useStyles();
  const history = useHistory();
  const headers = [
    { key: 'name', label: t('CAMPAIGN.TABLE_HEADERS.NAME') },
    { key: 'splits.date.start', label: t('CAMPAIGN.TABLE_HEADERS.START_DATE') },
    { key: 'splits.date.end', label: t('CAMPAIGN.TABLE_HEADERS.END_DATE') },
    { key: 'status', label: t('CAMPAIGN.TABLE_HEADERS.STATUS') },
  ];

  return (
    <div className={classes.container}>
      <table className={classes.table}>
        <thead>
          <tr className={classes.tableHeader}>
            {headers.map(({ key, label }) => (
              <th
                key={key}
                onClick={() => { onOrderByChange(key); }}
              >
                <span>{label}</span>
                {orderBy === key && (ascending ? <ChevronUp size="12" /> : <ChevronDown size="12" />)}
              </th>
            ))}
            <th />
          </tr>
        </thead>
        <tbody className={classes.tableBody}>
          {data.map(val => {
            const { dates, status } = val.splits[0];
            const { begin, end } = dates;
            const isActive = status === 'Active' && new Date() <= new Date(end);
            const isPaused = status === 'Paused'
            const currentStatus = isActive
              ? t('CAMPAIGN.CAMPAIGN_STATUS.ACTIVE')
              : isPaused
              ? t('CAMPAIGN.CAMPAIGN_STATUS.PAUSED')
              : t('CAMPAIGN.CAMPAIGN_STATUS.FINISHED');
            return (
              <tr key={val._id}>
                <td>{val.name}</td>
                <td>{dateFormat(begin)}</td>
                <td>{dateFormat(end)}</td>
                <td>{currentStatus}</td>
                <td>
                  <div className={classes.btnGroup}>
                    <EditButton onClick={() => { history.push(`/campaigns/edit/${val._id}`); }} />
                    <DeleteButton onClick={() => { openDeleteModal(val._id, val.name); }} />
                  </div>
                </td>
              </tr>
            )}
          )}
        </tbody>
      </table>
    </div>
  );
};


TableComponent.propTypes = {
  data: PropTypes.array.isRequired,
  onOrderByChange: PropTypes.func.isRequired,
  openDeleteModal: PropTypes.func.isRequired,
  orderBy: PropTypes.string.isRequired,
  ascending: PropTypes.oneOf([0, 1]).isRequired,
};

export default TableComponent;
